import use from 'reuse';



export default use;
